import {
    FormHelperText,
    Typography,
    Box,
    LinearProgress,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import { UploadIcon } from '../../../assets/svg';
import { Spinner } from '../';
import { getFileExtension, getFilename } from '../../../utils/helper';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { LightBoxImage } from '../index';
import { isVideoURL } from '../../../utils/helper';
import { getPresignedUrl } from '../../../store/actions/settingsActionCreator';
import axios from 'axios';
import { useDispatch } from 'react-redux';
const MAX_FILE_SIZE = 25600; // 5MB

// const IMAGE_FILES = ['.jpg', '.png', '.jpeg', '.bmp'];
const NON_IMAGE_FILES = ['.xlsx', '.csv', '.pdf', '.html'];
function LinearProgressWithLabel(props) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box minWidth={35}>
                <Typography
                    variant="body2"
                    color="textSecondary"
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

export const uploadImageOnS3 = (file, dispatch, onSuccess, onProgress, flowType) => {
    dispatch(
        getPresignedUrl(
            {
                fileName: getFilename(file.name),
                fileType: getFileExtension(file.name),
                contentType: file.type,
                ...(flowType ? { flowType } : {}),
            },
            async (response) => {
                const presignedUrl = response?.response?.presignedUrl;
                const getPreSignedUrl = response?.response?.getPreSignedUrl;
                if (!presignedUrl) {
                    return;
                }
                try {
                    await axios.put(presignedUrl, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                        onUploadProgress: (e) => {
                            if (!e?.total) return;
                            const percent = Math.round(
                                (e.loaded * 100) / e.total,
                            );
                            onProgress?.(percent);
                        },
                    });

                    // FIXME: for non-KYC uploads this strips the signature and yields a
                    // bare public S3 URL, which the caller then persists. That is the
                    // origin of most public URLs now stored in the database, and it will
                    // stop resolving once public reads are off. The presign response
                    // already returns `s3Key`; switching to it changes what several
                    // create/update APIs persist, so it needs its own change with a
                    // matching read-side resolver rather than being folded in here.
                    onSuccess?.(flowType ? getPreSignedUrl : presignedUrl.split('?')[0]);
                } catch (err) {
                    console.error('Upload failed', err);
                    return;
                }
            },
        ),
    );
};

export function FileUploader({
    render = null,
    label = '',
    labelStyles = null,
    placeholder = '',
    onFileUploaded = (url) => {},
    defaultValue = null,
    helperText = '',
    disabled = false,
    error = undefined,
    onRemoved = undefined,
    lightboxConfig = {},
    isRequired = false,
    download = false,
    disableS3Upload = false,
    flowType = '',
    accept = undefined,
    allowedExtensions = undefined,
    onValidationFail = undefined,
    ...props
}) {
    // const classes = useStyles();
    const [uploadedFile, setuploadedFile] = useState(defaultValue ?? '');
    const [loading, toggleLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setuploadedFile(defaultValue);
    }, [defaultValue]);

    const dispatch = useDispatch();

    const uploadfile = async (e) => {
        if (e.target.files.length > 0) {
            const selectedFile = e.target.files[0];

            if (allowedExtensions && allowedExtensions.length > 0) {
                const ext = selectedFile.name.split('.').pop()?.toLowerCase();
                if (!allowedExtensions.includes(ext)) {
                    e.target.value = '';
                    onValidationFail ? onValidationFail(ext) : alert(`Only ${allowedExtensions.map(x => '.' + x).join(', ')} files are allowed.`);
                    return;
                }
            }

            const fileSizeKiloBytes = selectedFile.size / 1024;

            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                alert(
                    `Maximum allowed size for a file is 25Mb.Upload less than 25Mb`,
                );
                return;
            }

            if (disableS3Upload) {
                const localPreviewUrl = URL.createObjectURL(selectedFile);
                setuploadedFile(localPreviewUrl);
                setProgress(100);
                onFileUploaded(selectedFile);
            } else {
                toggleLoading(true);

                uploadImageOnS3(
                    selectedFile,
                    dispatch,
                    (file) => {
                        onFileUploaded(file);
                        toggleLoading(false);
                        setuploadedFile(file);
                        setProgress(100);
                    },
                    (value) => {
                        setProgress(value);
                    },
                    flowType,
                );
            }
        }
    };

    const removeimage = () => {
        setuploadedFile('');
        setProgress('');
        onRemoved && onRemoved();
    };

    function getFileNameFromS3() {
        const lastSegment = uploadedFile.split('/')[uploadedFile.split('/').length - 1];
        return lastSegment.split('?')[0];
    }

    return (
        <>
            {!!label && (
                <Typography
                    variant="body1"
                    style={
                        labelStyles
                            ? {
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  marginTop: 10,
                                  marginBottom: 0,
                                  padding: 0,
                                  color: Boolean(error) ? '#F44336' : '#14112D',
                                  ...labelStyles,
                              }
                            : {
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  marginTop: 10,
                                  marginBottom: 0,
                                  padding: 0,
                                  color: Boolean(error) ? '#F44336' : '#515f6d',
                              }
                    }
                >
                    {label}
                    {isRequired && <span style={{ color: 'red' }}>*</span>}
                </Typography>
            )}
            <Spinner loading={loading}>
                <div className="file-upload">
                    {!!uploadedFile ? (
                        <div
                            className={`image-upload-wrap ${
                                Boolean(error) ? 'img-border-error' : ''
                            }`}
                        >
                            {!disabled && (
                                <div
                                    style={{
                                        display: 'flex',
                                        backgroundColor: 'red',
                                        borderRadius: '50%',
                                        position: 'absolute',
                                        top: -10,
                                        right: -10,
                                        zIndex: 99,
                                        color: '#fff',
                                        width: 25,
                                        height: 25,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                    onClick={(e) => removeimage()}
                                >
                                    {'X'}
                                </div>
                            )}
                            {/* <div className="drag-text"> */}
                            {!!uploadedFile &&
                            !NON_IMAGE_FILES.find((file) =>
                                uploadedFile.toLowerCase().includes(file),
                            ) ? (
                                <div className="drag-text image-drag">
                                    <LightBoxImage
                                        {...lightboxConfig}
                                        source={uploadedFile}
                                        download={download}
                                        type={
                                            isVideoURL(uploadedFile)
                                                ? 'video'
                                                : 'image'
                                        }
                                    />
                                </div>
                            ) : (
                                <div className="drag-text">
                                    <AttachFileIcon />
                                    <Box
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'flex-end',
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                color: '#1976d2',
                                                marginLeft: '2px',
                                                width: '100%',
                                                wordWrap: 'break-word',
                                                cursor: 'pointer',
                                                textDecoration: 'underline',
                                            }}
                                            onClick={() => window.open(uploadedFile, '_blank')}
                                        >
                                            {getFileNameFromS3()}
                                        </Typography>
                                    </Box>
                                </div>
                            )}
                            {/* </div> */}
                        </div>
                    ) : !render ? (
                        <div
                            className={`image-upload-wrap ${
                                Boolean(error) ? 'img-border-error' : ''
                            }`}
                        >
                            <input
                                className="file-upload-input"
                                type="file"
                                onChange={uploadfile}
                                disabled={disabled}
                                accept={accept}
                            />
                            <div className="drag-text">
                                <UploadIcon />
                                {progress > 0 && progress < 100 && (
                                    <LinearProgressWithLabel value={progress} />
                                )}
                                {!!placeholder && (
                                    <Typography variant="body1">
                                        {placeholder}
                                    </Typography>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div
                            className={` ${
                                Boolean(error) ? 'img-border-error' : ''
                            }`}
                        >
                            <input
                                className="file-upload-input"
                                type="file"
                                onChange={uploadfile}
                            />
                            {render()}
                        </div>
                    )}
                </div>
                {Boolean(error) && (
                    <FormHelperText className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                        {helperText}
                    </FormHelperText>
                )}
            </Spinner>
        </>
    );
}
